export default "__VITE_ASSET__6B2RAuuw__"